/**
 * Wires `attributionFees.model.ts` to its one read.
 *
 * `fetchAttributionServiceCases` is the same read the Verifications tab makes:
 * every case the caller is party to, both sides. The model keeps the studio's
 * charged ones. No write lives here — recording a payment or a correction is
 * the Verifications tab's, beside the case, and this centre says so.
 */

import { useEffect, useState } from "react";
import type { AttributionServiceCase } from "@ondo/shared";

import { fetchAttributionServiceCases } from "../lib/api/attributionService.ts";
import {
  describeAttributionFeesError,
  toAttributionFeesView,
} from "./attributionFees.model.ts";
import type { AttributionFeesView } from "./attributionFees.model.ts";

export function useAttributionFeesController(): { view: AttributionFeesView } {
  const [cases, setCases] = useState<AttributionServiceCase[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;

    fetchAttributionServiceCases()
      .then((found) => {
        if (active) setCases(found);
      })
      .catch((cause: unknown) => {
        if (active) setError(describeAttributionFeesError(cause));
      });

    return () => {
      active = false;
    };
  }, []);

  return { view: toAttributionFeesView({ cases, error }) };
}
